import lodash from 'lodash'

import api from '@/api/api'

export default {
	name: 'private-header',
	data () {
		return {}
	},
	methods : {
		asideToggle () {

			this.$root.$emit('asideToggle')

		}
	}
}


// WEBPACK FOOTER //
// ./src/components/private/header/script.js